import { SpinnerContainer, SpinnerOverlay } from "./spinner.styles";

export default function Spinner() {
  return (
    <SpinnerOverlay>
      <SpinnerContainer></SpinnerContainer>
    </SpinnerOverlay>
  );
}
